import React from 'react'
import PropTypes from 'prop-types'
import { Media, Row } from 'react-bootstrap'
import Image from 'components/image'

const Author = (props) => {
  var { author, className } = { ...props }

  return (
    <Row className={className}>
      <hr className="mbl" />
      <Media className="col-sm-12">
        <Media.Left>
          {author.photo ? (
            <Image
              alt="author"
              className="thumbnail-profile"
              src={author.photo.url}
            />
          ) : null}
        </Media.Left>
        <Media.Body>
          <div
            className="mts mbn pll"
            dangerouslySetInnerHTML={{ __html: author.bio }}
          />
        </Media.Body>
      </Media>
    </Row>
  )
}

Author.propTypes = {
  author: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default Author
